// Scroll Reveal Animation Utility
export const initScrollReveal = () => {
  const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -80px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        // Add a slight delay for staggered animations
        setTimeout(() => {
          entry.target.classList.add('revealed');
          // Add animation class based on data attribute
          const animationType = entry.target.dataset.reveal || 'fade-up';
          entry.target.classList.add(`reveal-${animationType}`);
        }, index * 100);
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe all sections
  const sections = document.querySelectorAll('section');
  sections.forEach(section => {
    section.classList.add('reveal-on-scroll', 'reveal-fade-up');
    observer.observe(section);
  });

  // Observe all elements with reveal classes
  const revealElements = document.querySelectorAll('.reveal-on-scroll, [data-reveal]');
  revealElements.forEach(el => observer.observe(el));

  // Observe section headers, titles, descriptions, and cards
  const textElements = document.querySelectorAll(
    '.section-header, .section-title, .section-description, ' +
    '.service-card, .milestone-card, .value-card, ' +
    '.stat-card, .testimonial-card, .portfolio-item, ' +
    '.blog-card, .process-step, .faq-item, ' +
    'h1, h2, h3, h4, h5, h6'
  );
  
  textElements.forEach((el, index) => {
    if (!el.closest('.hero-exact')) { // Exclude hero section
      el.classList.add('reveal-on-scroll', 'reveal-fade-up');
      observer.observe(el);
    }
  });
};

// Initialize on page load
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    setTimeout(initScrollReveal, 100);
  });
  
  // Re-initialize on route changes
  window.addEventListener('popstate', () => {
    setTimeout(initScrollReveal, 100);
  });
}

